var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0106C0 17.9677 0.352063 19.8424 0.995188 21.5758L16 22.2714L31.0048 21.5758C31.648 19.8424 32 17.9677 32 16.0106C32 14.0535 31.648 12.1787 31.0048 10.4454L16 9.74971L0.995188 10.4453C0.352063 12.1787 0 14.0535 0 16.0106H0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0.0107422C9.12074 0.0107422 3.25605 4.35274 0.995361 10.4456H31.005C28.7443 4.35274 22.8796 0.0107422 16.0002 0.0107422V0.0107422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.005 21.576H0.995361C3.25605 27.6687 9.12074 32.0108 16.0002 32.0108C22.8796 32.0108 28.7443 27.6687 31.005 21.576Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonia);
export default __webpack_public_path__ + "static/media/estonia.2f53e56e.svg";
export { ForwardRef as ReactComponent };